module.exports = __webpack_public_path__ + "static/media/jfvideo-placeholder.0955dcf5.png";